const apiBaseUrl = "https://wmrg02z3nl.execute-api.us-west-2.amazonaws.com/prod/";
export default apiBaseUrl;